/* MoRetro Studio V19.0 — Projects + prix isolés par projet */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";


  function injectV18Styles(){
    if(document.getElementById("mtsV18Styles")) return;

    const style = document.createElement("style");
    style.id = "mtsV18Styles";
    style.textContent = `
      .mts-v18-shell .mts-v7-center{gap:18px}
      .mts-v18-order-grid{grid-template-columns:repeat(2,minmax(0,1fr))}
      .mts-v18-control-panel{display:flex;justify-content:flex-end;align-items:stretch;gap:12px;margin-top:18px;flex-wrap:wrap}
      .mts-v18-control-panel .mts-v18-checkout-btn{border:1px solid rgba(255,255,255,.16);background:rgba(255,255,255,.06);color:#fff;border-radius:16px;padding:13px 18px;font-weight:900;cursor:pointer;min-height:54px}
      .mts-v18-control-panel .mts-v18-checkout-btn:hover{background:linear-gradient(135deg,rgba(255,43,43,.22),rgba(123,44,255,.22),rgba(0,212,255,.22))}
      .mts-v18-control-panel .mts-v7-main-action{min-width:190px;min-height:54px;margin:0}
      .mts-v18-steps{grid-template-columns:repeat(8,minmax(0,1fr))}

      .mts-v18-steps > div{opacity:.48;filter:saturate(.45);transition:.2s ease}
      .mts-v18-steps > div span{border:2px solid rgba(255,255,255,.18);background:rgba(255,255,255,.06);box-shadow:none;transition:.2s ease}
      .mts-v18-steps > div.done{opacity:1;filter:saturate(1)}
      .mts-v18-steps > div.done span{background:linear-gradient(135deg,#00c853,#00e5ff);border-color:#21ff8a;box-shadow:0 0 0 4px rgba(0,200,83,.12),0 0 18px rgba(0,229,255,.22)}
      .mts-v18-steps > div.done em{color:#7dffad}
      .mts-v18-steps > div.active{opacity:1;filter:saturate(1.2)}
      .mts-v18-steps > div.active span{background:linear-gradient(135deg,#ff7a18,#ff2bd6,#00d4ff);border-color:#ffbd57;box-shadow:0 0 0 5px rgba(255,122,24,.15),0 0 22px rgba(255,43,214,.25)}
      .mts-v18-steps > div.active em{color:#ffd36d}
      .mts-v7-more-actions,.mts-project-main-actions{display:none!important}
      .mts-doc-summary{display:flex;gap:8px;flex-wrap:wrap;margin:10px 0 0}
      .mts-doc-pill{display:inline-flex;align-items:center;gap:6px;border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.06);border-radius:999px;padding:7px 10px;color:#fff;font-weight:800;font-size:12px}
      .mts-smart-files{display:grid;gap:14px}
      .mts-file-section{border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.045);border-radius:18px;padding:14px}
      .mts-file-section h4{margin:0 0 10px;color:#fff;font-size:15px}
      .mts-file-row{display:flex;align-items:center;justify-content:space-between;gap:12px;border:1px solid rgba(255,255,255,.09);background:rgba(0,0,0,.16);border-radius:14px;padding:12px;margin-top:8px}
      .mts-file-row strong{display:block;color:#fff;margin-bottom:4px}
      .mts-file-row span{display:block;color:rgba(255,255,255,.68);font-size:12px;line-height:1.45}
      .mts-file-row a{white-space:nowrap;border-radius:12px;padding:9px 12px;background:linear-gradient(135deg,#ff2b2b,#7b2cff,#00d4ff);color:#fff;text-decoration:none;font-weight:900;font-size:12px}
      .mts-file-row .mts-file-no-link{white-space:nowrap;border-radius:12px;padding:9px 12px;background:rgba(255,255,255,.08);color:rgba(255,255,255,.7);font-weight:800;font-size:12px;border:0;cursor:pointer}
      .mts-workshop-bar{border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.045);border-radius:20px;padding:14px 16px;margin:0 0 18px;position:relative;overflow:visible}
      .mts-workshop-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:10px;color:#fff;font-weight:900}
      .mts-workshop-head span{color:rgba(255,255,255,.62);font-size:12px;font-weight:800}
      .mts-workshop-grid{display:grid;grid-template-columns:repeat(7,minmax(78px,1fr));gap:8px;text-align:center;align-items:start}
      .mts-workshop-name{color:rgba(255,255,255,.86);font-size:12px;font-weight:900;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .mts-workshop-state{margin-top:7px;border:1px solid rgba(255,255,255,.12);background:rgba(0,0,0,.18);border-radius:999px;min-height:30px;padding:7px 7px;color:#fff;font-size:12px;font-weight:900;white-space:nowrap;cursor:pointer;user-select:none}
      .mts-workshop-state.free{color:#6dff9a}.mts-workshop-state.reserved{color:#ffbd57}.mts-workshop-state.printing{color:#ff7272}.mts-workshop-state.overdue{color:#ffd057}.mts-workshop-state.finish{color:#b985ff}
      .mts-printer-tip{position:absolute;right:16px;top:66px;z-index:40;width:min(320px,calc(100vw - 40px));border:1px solid rgba(255,255,255,.16);background:#11131d;border-radius:18px;padding:15px;box-shadow:0 20px 60px rgba(0,0,0,.35);color:#fff;text-align:left}
      .mts-printer-tip strong{display:block;margin-bottom:8px}.mts-printer-tip p{margin:6px 0;color:rgba(255,255,255,.78);font-size:13px;line-height:1.35}.mts-printer-tip button{float:right;border:0;background:rgba(255,255,255,.08);color:#fff;border-radius:10px;padding:4px 8px;cursor:pointer}
      .mts-v18-menu-wrap{position:relative;margin-left:auto}.mts-v18-menu-btn{border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.06);color:#fff;border-radius:14px;width:42px;height:42px;font-size:22px;cursor:pointer;font-weight:900}.mts-v18-menu{position:absolute;right:0;top:48px;z-index:30;width:310px;max-height:min(70vh,640px);overflow:auto;border:1px solid rgba(255,255,255,.14);background:#11131d;border-radius:16px;padding:8px;box-shadow:0 20px 50px rgba(0,0,0,.35)}.mts-v18-menu-title{padding:10px 12px 5px;color:#8f97aa;font-size:10px;font-weight:900;letter-spacing:.12em;text-transform:uppercase}.mts-v18-menu-sep{height:1px;background:rgba(255,255,255,.09);margin:7px 4px}.mts-v18-menu button{display:block;width:100%;text-align:left;border:0;background:transparent;color:#fff;padding:10px 12px;border-radius:12px;cursor:pointer;font-weight:800}.mts-v18-menu button:hover{background:rgba(255,255,255,.08)}.mts-v18-menu button.danger{color:#ff8a8a}
      @media(max-width:1100px){
        .mts-workshop-grid{grid-template-columns:repeat(4,minmax(78px,1fr))}
      }
      @media(max-width:760px){
        .mts-v18-order-grid{grid-template-columns:1fr}
        .mts-v18-control-panel{justify-content:stretch}
        .mts-v18-control-panel .mts-v18-checkout-btn,.mts-v18-control-panel .mts-v7-main-action{width:100%;min-width:0}
        .mts-v18-steps{grid-template-columns:repeat(4,minmax(0,1fr))}
        .mts-workshop-grid{grid-template-columns:repeat(2,minmax(90px,1fr))}
      }
    `;
    document.head.appendChild(style);
  }

  injectV18Styles();
  setTimeout(()=>{ renderWorkshopBar(); startWorkshopTimer(); }, 800);


  function projectTabButton(id, label, active){
    return `<button type="button" class="mts-project-tab ${active ? "active" : ""}" data-project-tab="${id}">${label}</button>`;
  }

  function renderTimeline(project){
    const history = Array.isArray(project.history) ? project.history : [];
    const base = [
      {label:"Demande reçue", date:project.createdAt ? MTS.dateLabel(project.createdAt) : ""},
      ...(project.quote || project.autoQuote ? [{label:"Devis créé", date:project.updatedAt ? MTS.dateLabel(project.updatedAt) : ""}] : []),
      ...history.map(h=>({label:h.label || h.type || "Action", date:h.date ? new Date(h.date).toLocaleString("fr-FR") : ""}))
    ];

    return `
      <div class="mts-timeline">
        ${base.map(item=>`
          <div class="mts-timeline-item">
            <span></span>
            <div><strong>${MTS.escapeHtml(item.label)}</strong><em>${MTS.escapeHtml(item.date || "")}</em></div>
          </div>
        `).join("")}
      </div>
    `;
  }

  function renderGallery(project){
    const images = (Array.isArray(project.files) ? project.files : []).filter(MTS.Files.isImageFile);

    if(!images.length) return `<div class="mts-empty">Aucune image dans ce projet.</div>`;

    return `
      <div class="mts-gallery-grid">
        ${images.map(f=>`<a href="${MTS.escapeHtml(f.url)}" target="_blank" rel="noopener"><img src="${MTS.escapeHtml(f.url)}" alt="${MTS.escapeHtml(f.name||"Image")}" loading="lazy"></a>`).join("")}
      </div>
    `;
  }


  function cleanDateLabel(value){
    if(!value) return new Date().toLocaleString("fr-FR");
    try{
      if(value.toDate) return value.toDate().toLocaleString("fr-FR");
      return new Date(value).toLocaleString("fr-FR");
    }catch(e){
      return String(value || "");
    }
  }

  function fileKind(file = {}){
    const type = String(file.type || file.documentType || file.kind || "").toLowerCase();
    const name = String(file.name || "").toLowerCase();
    const mime = String(file.mimeType || file.mime || "").toLowerCase();

    if(type.includes("quote") || type.includes("devis") || type.includes("payment_link") || name.includes("devis") || name.includes("paiement") || name.includes("draft")) return "documents";
    if(type.includes("payment") || type.includes("paiement") || name.includes("paiement")) return "documents";
    if(type.includes("shipping") || type.includes("label") || type.includes("suivi") || type.includes("tracking")) return "shipping";
    if((MTS.Files && MTS.Files.isImageFile && MTS.Files.isImageFile(file)) || mime.startsWith("image/") || /\.(jpg|jpeg|png|webp|gif)$/i.test(name)) return "photos";
    if(/\.(stl|3mf|obj|step|stp|gcode|gx|lys|blend|f3d)$/i.test(name) || type.includes("3d")) return "printing";
    return "other";
  }

  function documentSummary(project){
    const files = Array.isArray(project.files) ? project.files : [];
    const counts = {documents:0, printing:0, photos:0, shipping:0};
    files.forEach(f=>{ const k=fileKind(f); if(counts[k] !== undefined) counts[k]++; });
    return `
      <div class="mts-doc-summary">
        <span class="mts-doc-pill">📄 ${counts.documents} document(s)</span>
        <span class="mts-doc-pill">🧩 ${counts.printing} fichier(s) 3D</span>
        <span class="mts-doc-pill">📷 ${counts.photos} photo(s)</span>
        <span class="mts-doc-pill">🚚 ${counts.shipping} suivi(s)</span>
      </div>
    `;
  }

  function renderFileRow(file){
    const icon = file.icon || (fileKind(file)==="documents" ? "📄" : fileKind(file)==="shipping" ? "🚚" : fileKind(file)==="photos" ? "📷" : fileKind(file)==="printing" ? "🧩" : "📎");
    const name = file.name || file.title || "Fichier";
    const meta = [
      file.amount ? `💶 ${MTS.money ? MTS.money(Number(file.amount)) : file.amount + " €"}` : "",
      file.shopifyRef ? `📦 ${file.shopifyRef}` : "",
      file.trackingNumber ? `🚚 ${file.trackingNumber}` : "",
      file.createdAt ? `📅 ${cleanDateLabel(file.createdAt)}` : ""
    ].filter(Boolean).join(" • ");

    return `
      <div class="mts-file-row">
        <div>
          <strong>${icon} ${MTS.escapeHtml(name)}</strong>
          <span>${MTS.escapeHtml(meta || file.description || "Document enregistré dans la fiche projet")}</span>
        </div>
        ${file.documentType === "quote_pdf" || file.type === "quote_pdf"
          ? `<button type="button" class="mts-file-no-link" data-open-saved-quote-pdf="${MTS.escapeHtml(file.id || "")}">Voir PDF</button>`
          : (file.url ? `<a href="${MTS.escapeHtml(file.url)}" target="_blank" rel="noopener">Ouvrir</a>` : `<span class="mts-file-no-link">Archivé</span>`)}
      </div>
    `;
  }

  function renderSmartFiles(project){
    const files = Array.isArray(project.files) ? project.files : [];
    const groups = [
      ["documents", "📁 Documents"],
      ["printing", "📁 Impression 3D"],
      ["photos", "📁 Photos"],
      ["shipping", "📁 Expédition / suivi"],
      ["other", "📁 Autres fichiers"]
    ];

    const body = groups.map(([kind,label])=>{
      const items = files.filter(f=>fileKind(f) === kind);
      if(!items.length) return "";
      return `<div class="mts-file-section"><h4>${label}</h4>${items.map(renderFileRow).join("")}</div>`;
    }).join("");

    return `
      ${MTS.Files.renderUploader()}
      ${documentSummary(project)}
      <div class="mts-smart-files">
        ${body || `<div class="mts-empty">Aucun fichier enregistré pour ce projet.</div>`}
      </div>
    `;
  }

  function quoteFileRecord(project, data = {}, action = "created"){
    const price = projectPrice(project);
    const draftName = data.draftOrderName || project.shopifyDraftOrderName || "Devis Shopify";
    const url = data.invoiceUrl || project.shopifyInvoiceUrl || "";
    const sent = action === "sent";

    return {
      id:`payment-link-${Date.now()}-${Math.random().toString(16).slice(2)}`,
      type: sent ? "payment_link_sent" : "payment_link_created",
      documentType:"payment_link",
      icon: sent ? "💳" : "🔗",
      name: sent ? `Lien paiement envoyé ${draftName}` : `Lien paiement Shopify ${draftName}`,
      description: sent ? "Lien de paiement Shopify envoyé au client" : "Lien de paiement Shopify généré",
      url,
      amount: price || "",
      shopifyRef:draftName,
      createdAt:new Date().toISOString()
    };
  }


  const MTS_PRINTERS = [
    "Ender 3 V3 SE #1",
    "Ender 3 V3 SE #2",
    "Sidewinder X4 Plus",
    "Kobra S1",
    "P2S #1",
    "P2S #2",
    "H2D"
  ];

  function normalizePrinterName(value){
    const raw = String(value || "").trim();
    if(!raw) return "";
    const low = raw.toLowerCase().replace(/\s+/g," ");
    if(low.includes("ender") && (low.includes("#1") || low.includes(" 1"))) return "Ender 3 V3 SE #1";
    if(low.includes("ender") && (low.includes("#2") || low.includes(" 2"))) return "Ender 3 V3 SE #2";
    if(low.includes("sidewinder") || low.includes("x4")) return "Sidewinder X4 Plus";
    if(low.includes("kobra")) return "Kobra S1";
    if(low.includes("p2s") && (low.includes("#1") || low.includes(" 1"))) return "P2S #1";
    if(low.includes("p2s") && (low.includes("#2") || low.includes(" 2"))) return "P2S #2";
    if(low === "p2s") return "P2S #1";
    if(low.includes("h2d")) return "H2D";
    return raw;
  }

  function getNestedValues(obj, matcher, depth = 0, out = []){
    if(!obj || typeof obj !== "object" || depth > 4) return out;
    Object.entries(obj).forEach(([key,value])=>{
      const k = String(key || "").toLowerCase();
      if(matcher(k, value)) out.push(value);
      if(value && typeof value === "object" && !Array.isArray(value)) getNestedValues(value, matcher, depth + 1, out);
    });
    return out;
  }

  function projectPrinter(project = {}){
    const direct = project.printer || project.printerName || project.usedPrinter || project.selectedPrinter || project.imprimante || project.imprimanteUtilisee || project.machine || project.machineName || project.quotePrinter || project.printPrinter;
    if(direct) return normalizePrinterName(direct);
    const vals = getNestedValues(project, (k,v)=> (k.includes("printer") || k.includes("imprimante") || k.includes("machine")) && typeof v !== "object");
    return normalizePrinterName(vals.find(Boolean) || "");
  }

  function parsePrintMinutes(value, key = ""){
    if(value === null || value === undefined || value === "") return 0;
    if(typeof value === "number" && Number.isFinite(value)){
      if(String(key).toLowerCase().includes("hour") || String(key).toLowerCase().includes("heure")) return Math.round(value * 60);
      if(value > 0 && value <= 24) return Math.round(value * 60);
      return Math.round(value);
    }
    const s = String(value).toLowerCase().trim().replace(",", ".");
    let m = s.match(/(\d+(?:\.\d+)?)\s*h(?:eure|ours?)?\s*(\d+)?/i);
    if(m) return Math.round(Number(m[1]) * 60 + Number(m[2] || 0));
    m = s.match(/(\d{1,2})\s*[:h]\s*(\d{1,2})/);
    if(m) return Number(m[1]) * 60 + Number(m[2]);
    m = s.match(/(\d+(?:\.\d+)?)\s*(min|mn|minutes?)/);
    if(m) return Math.round(Number(m[1]));
    m = s.match(/\d+(?:\.\d+)?/);
    if(m){
      const n = Number(m[0]);
      if(n > 0 && n <= 24) return Math.round(n * 60);
      return Math.round(n);
    }
    return 0;
  }

  function projectPrintMinutes(project = {}){
    const directKeys = ["estimatedPrintMinutes","printEstimatedMinutes","estimatedPrintTime","printTime","printDuration","estimatedTime","productionTime","printHours","tempsImpression","tempsEstime","dureeImpression","duration"];
    for(const k of directKeys){
      if(project[k]) return parsePrintMinutes(project[k], k);
    }
    const vals = getNestedValues(project, (k,v)=>{
      if(typeof v === "object") return false;
      const isTimeKey = (k.includes("print") || k.includes("impression") || k.includes("temps") || k.includes("duree") || k.includes("durée") || k.includes("time") || k.includes("duration"));
      const forbidden = k.includes("created") || k.includes("updated") || k.includes("date") || k.includes("started") || k.includes("ended");
      return isTimeKey && !forbidden;
    });
    for(const v of vals){
      const mins = parsePrintMinutes(v);
      if(mins) return mins;
    }
    return 0;
  }

  function formatRemaining(ms){
    const total = Math.max(0, Math.ceil(ms / 1000));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    return `${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}`;
  }

  function dateMs(value){
    try{
      if(!value) return 0;
      if(value.toDate) return value.toDate().getTime();
      const d = new Date(value).getTime();
      return Number.isFinite(d) ? d : 0;
    }catch(e){ return 0; }
  }

  function printerStateMap(){
    const map = {};
    MTS_PRINTERS.forEach(name=>map[name] = {state:"free", project:null, label:"🟢", title:"Libre"});
    const projects = Array.isArray(MTS.state.projects) ? MTS.state.projects : [];

    projects.forEach(project=>{
      const printer = projectPrinter(project);
      if(!printer || !map[printer]) return;
      const status = project.status || "new";
      const current = map[printer];

      if(status === "printing"){
        const started = dateMs(project.printStartedAt || project.productionStartedAt || project.startedAt);
        const minutes = Number(project.printEstimatedMinutes || project.estimatedPrintMinutes || 0) || projectPrintMinutes(project);
        const end = started && minutes ? started + minutes * 60000 : 0;
        const remaining = end ? end - Date.now() : 0;
        map[printer] = {
          state: end && remaining <= 0 ? "overdue" : "printing",
          project,
          label: end ? (remaining <= 0 ? `⚠️ +${formatRemaining(Math.abs(remaining))}` : `🔴 ${formatRemaining(remaining)}`) : "🔴 En cours",
          title: end && remaining <= 0 ? "Temps dépassé" : "En impression"
        };
        return;
      }

      // L'imprimante est réservée seulement quand le devis est accepté / paiement validé,
      // pas dès la simple création ou l'envoi du devis Shopify.
      if(["accepted","paid"].includes(status) && current.state === "free"){
        map[printer] = {state:"reserved", project, label:"🟠", title:"Réservée"};
      }
    });

    return map;
  }

  function renderWorkshopBar(){
    const topbar = document.querySelector(".mts-topbar");
    if(!topbar) return;

    let bar = document.getElementById("mtsWorkshopBar");
    if(!bar){
      bar = document.createElement("section");
      bar.id = "mtsWorkshopBar";
      bar.className = "mts-workshop-bar";
      topbar.insertAdjacentElement("afterend", bar);
    }

    const map = printerStateMap();
    const busy = Object.values(map).filter(x=>x.state === "printing" || x.state === "overdue").length;
    const reserved = Object.values(map).filter(x=>x.state === "reserved").length;

    bar.innerHTML = `
      <div class="mts-workshop-head"><strong>🖨️ Atelier</strong><span>${busy} en impression • ${reserved} réservée(s)</span></div>
      <div class="mts-workshop-grid">
        ${MTS_PRINTERS.map(name=>`<div><div class="mts-workshop-name">${MTS.escapeHtml(name)}</div><div class="mts-workshop-state ${map[name].state}" data-printer-name="${MTS.escapeHtml(name)}" title="${MTS.escapeHtml(map[name].title)}">${MTS.escapeHtml(map[name].label)}</div></div>`).join("")}
      </div>
    `;
  }

  function bindWorkshopBar(){
    document.addEventListener("click", (event)=>{
      const state = event.target.closest("[data-printer-name]");
      const existing = document.getElementById("mtsPrinterTip");
      if(existing) existing.remove();
      if(!state) return;
      const name = state.dataset.printerName;
      const data = printerStateMap()[name];
      const project = data && data.project;
      const bar = document.getElementById("mtsWorkshopBar");
      if(!bar) return;
      const started = project ? dateMs(project.printStartedAt || project.productionStartedAt || project.startedAt) : 0;
      const mins = project ? (Number(project.printEstimatedMinutes || project.estimatedPrintMinutes || 0) || projectPrintMinutes(project)) : 0;
      const end = started && mins ? new Date(started + mins * 60000).toLocaleTimeString("fr-FR", {hour:"2-digit", minute:"2-digit"}) : "—";
      const html = project ? `
        <button type="button" data-close-printer-tip>×</button>
        <strong>🖨️ ${MTS.escapeHtml(name)}</strong>
        <p><b>État :</b> ${MTS.escapeHtml(data.title)}</p>
        <p><b>Projet :</b> ${MTS.escapeHtml(project.projectType || "Projet")}</p>
        <p><b>Client :</b> ${MTS.escapeHtml(project.name || "—")}</p>
        <p><b>Début :</b> ${started ? new Date(started).toLocaleTimeString("fr-FR", {hour:"2-digit", minute:"2-digit"}) : "—"}</p>
        <p><b>Fin estimée :</b> ${MTS.escapeHtml(end)}</p>
      ` : `
        <button type="button" data-close-printer-tip>×</button>
        <strong>🖨️ ${MTS.escapeHtml(name)}</strong>
        <p><b>État :</b> Libre</p>
      `;
      const tip = document.createElement("div");
      tip.id = "mtsPrinterTip";
      tip.className = "mts-printer-tip";
      tip.innerHTML = html;
      bar.appendChild(tip);
    });

    document.addEventListener("click", (event)=>{
      if(event.target.closest("[data-close-printer-tip]")) document.getElementById("mtsPrinterTip")?.remove();
    });
  }

  function startWorkshopTimer(){
    if(MTS.state.workshopTimer) return;
    MTS.state.workshopTimer = setInterval(renderWorkshopBar, 1000);
    bindWorkshopBar();
  }

  function renderTabs(project){
    const active = MTS.state.activeProjectTab || "project";

    const tabs = `
      <div class="mts-project-tabs">
        ${projectTabButton("project","📄 Projet",active==="project")}
        ${projectTabButton("files","📁 Fichiers",active==="files")}
        ${projectTabButton("quote","💰 Devis",active==="quote")}
        ${projectTabButton("production","🖨 Production",active==="production")}
        ${projectTabButton("gallery","📷 Galerie",active==="gallery")}
        ${projectTabButton("notes","📝 Notes",active==="notes")}
        ${projectTabButton("history","📜 Historique",active==="history")}
      </div>
    `;

    let content = "";

    if(active === "project"){
      content = `
        <div class="mts-detail-grid">
          <div class="mts-detail-box"><span>Client</span><strong>${MTS.escapeHtml(project.name||"Non renseigné")}</strong></div>
          <div class="mts-detail-box"><span>Email</span><a href="mailto:${MTS.escapeHtml(project.email||"")}">${MTS.escapeHtml(project.email||"Non renseigné")}</a></div>
          <div class="mts-detail-box"><span>Téléphone</span><strong>${MTS.escapeHtml(project.phone||"Non renseigné")}</strong></div>
          <div class="mts-detail-box"><span>Budget</span><strong>${MTS.escapeHtml(project.budget||"À définir")}</strong></div>
        </div>
        <div class="mts-detail-message"><span>Description</span><p>${MTS.escapeHtml(project.message||"")}</p></div>
      `;
    }

    if(active === "files"){
      content = renderSmartFiles(project);
    }

    if(active === "quote"){
      content = MTS.Quotes.renderQuoteBox(project);
    }

    if(active === "production"){
      content = `
        <div class="mts-production-box">
          <h4>🖨 Suivi de production</h4>
          <p class="mts-muted">Le changement d'étape se fait maintenant uniquement avec le bouton principal en haut de la fiche.</p>
          <div class="mts-detail-grid">
            <div class="mts-detail-box"><span>Statut actuel</span><strong>${MTS.escapeHtml(MTS.statusLabel(project.status))}</strong></div>
            <div class="mts-detail-box"><span>Commande</span><strong>${MTS.escapeHtml(shopifyRef(project))}</strong></div>
          </div>
        </div>
      `;
    }

    if(active === "gallery"){
      content = renderGallery(project);
    }

    if(active === "notes"){
      content = `
        <div class="mts-internal-notes">
          <label for="mtsInternalNotes">Notes internes</label>
          <textarea id="mtsInternalNotes" placeholder="Notes atelier, réglages, idées de prix...">${MTS.escapeHtml(project.internalNotes||"")}</textarea>
          <div class="mts-actions">
            <button class="mts-btn mts-soft" type="button" id="mtsSaveNotes">Enregistrer les notes</button>
          </div>
        </div>
      `;
    }

    if(active === "history"){
      content = (MTS.History && typeof MTS.History.render === "function") ? MTS.History.render(project) : renderTimeline(project);
    }

    return tabs + `<div class="mts-project-tab-content">${content}</div>`;
  }

  function filtered(){
    const search = (MTS.$("mtsProjectSearch")?.value || "").toLowerCase().trim();
    const status = MTS.$("mtsProjectStatus")?.value || "new";
    const sort = MTS.$("mtsProjectSort")?.value || "recent";
    let arr = [...MTS.state.projects];

    if(status !== "all") arr = arr.filter(p=>(p.status || "new") === status);

    if(search){
      arr = arr.filter(p=>[
        p.name,p.email,p.phone,p.projectType,p.budget,p.message,
        Array.isArray(p.files) ? p.files.map(f=>f.name).join(" ") : ""
      ].join(" ").toLowerCase().includes(search));
    }

    arr.sort((a,b)=> sort === "old" ? MTS.millis(a.createdAt)-MTS.millis(b.createdAt) : MTS.millis(b.createdAt)-MTS.millis(a.createdAt));

    return arr;
  }

  function renderList(){
    const wrap = MTS.$("mtsProjectList");
    if(!wrap) return;

    const projects = filtered();

    if(!projects.length){
      wrap.innerHTML = '<div class="mts-empty">Aucun projet trouvé.</div>';
      renderDetail(null);
      return;
    }

    if(!MTS.state.selectedProjectId || !projects.some(p=>p.id === MTS.state.selectedProjectId)){
      MTS.state.selectedProjectId = projects[0].id;
    }

    wrap.innerHTML = projects.map(p=>`
      <button type="button" class="mts-crm-item ${p.id===MTS.state.selectedProjectId ? "active" : ""}" data-project-id="${MTS.escapeHtml(p.id)}">
        <div class="mts-crm-item-top">
          <strong>${MTS.escapeHtml(p.name||"Client")}</strong>
          <span class="mts-badge ${MTS.escapeHtml(p.status||"new")}">${MTS.escapeHtml(MTS.statusLabel(p.status))}</span>
        </div>
        <span>${MTS.escapeHtml(p.projectType||"Projet")}<br>${MTS.escapeHtml(MTS.dateLabel(p.createdAt))}<br>${Array.isArray(p.files)?p.files.length:0} fichier(s)</span>
      </button>
    `).join("");

    renderDetail(MTS.state.projects.find(p=>p.id === MTS.state.selectedProjectId));
    renderWorkshopBar();
  }


  function hasQuoteData(project = {}){
    return !!(
      project.shopifyDraftOrderId
      || project.shopifyInvoiceUrl
      || project.shopifyDraftOrderName
      || project.shopifyOrderId
      || project.shopifyOrderName
      || project.quote
      || project.autoQuote
      || project.finalPrice
      || project.quoteTotal
      || ["quoted","accepted","paid","printing","finishing","ready","shipped","done"].includes(String(project.status || ""))
    );
  }

  function parseMoneyValue(raw){
    if(raw === null || raw === undefined || raw === "") return 0;
    if(typeof raw === "number") return Number.isFinite(raw) && raw > 0 ? raw : 0;

    const str = String(raw).trim();

    // Important : un budget du type "20-50 €" ne doit jamais devenir 2050 €.
    // Les plages de prix restent un budget client, pas un montant de devis.
    if(/\d+\s*[-–—]\s*\d+/.test(str)) return 0;

    const cleaned = str
      .replace(/\s/g, "")
      .replace(/€/g, "")
      .replace(/[^0-9.,]/g, "")
      .replace(/,(?=\d{1,2}$)/, ".");

    if(!cleaned) return 0;

    const value = Number(cleaned.replace(/,/g, ""));
    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function firstMoneyValue(values){
    for(const raw of values){
      const value = parseMoneyValue(raw);
      if(value) return value;
    }
    return 0;
  }

  function projectPrice(project = {}){
    const liveAutoQuote = (MTS.state && MTS.state.selectedProjectId === project.id && MTS.state.lastAutoQuote) ? MTS.state.lastAutoQuote : null;
    const quote = project.quote || {};
    const autoQuoteSource = liveAutoQuote || project.autoQuote || null;
    const autoQuote = (autoQuoteSource && autoQuoteSource.quote) ? autoQuoteSource.quote : {};

    // Priorité aux vrais devis générés / calculés.
    const quotePrice = firstMoneyValue([
      quote.price, quote.total, quote.final, quote.suggested, quote.amount,
      autoQuote.final, autoQuote.total, autoQuote.suggested, autoQuote.price, autoQuote.amount
    ]);
    if(quotePrice) return quotePrice;

    // Sur une nouvelle demande, on ignore les champs budget / price hérités du formulaire client.
    // Le montant ne devient réel qu'après calcul/génération du devis.
    if(!hasQuoteData(project)) return 0;

    return firstMoneyValue([
      project.finalPrice,
      project.quoteTotal,
      project.total,
      project.amount,
      project.paidAmount,
      project.price
    ]);
  }

  function savedPricePayload(project){
    const price = projectPrice(project);
    if(!price) return {};

    return {
      finalPrice: price,
      quoteTotal: price,
      quote: {
        ...(project.quote || {}),
        price,
        total: price,
        final: price,
        updatedAt: new Date().toISOString()
      }
    };
  }





  function getReliableQuote(project = {}){
    // Source unique fiable :
    // 1. Devis affiché/calculé dans l'onglet Devis.
    // 2. Dernier devis calculé en mémoire.
    // 3. Devis déjà enregistré sur le projet.
    if(MTS.Quotes && typeof MTS.Quotes.getCurrentQuote === "function"){
      const live = MTS.Quotes.getCurrentQuote(project);
      if(live && live.quote) return live;
    }

    if(MTS.state && MTS.state.selectedProjectId === project.id && MTS.state.lastAutoQuote && MTS.state.lastAutoQuote.quote){
      return MTS.state.lastAutoQuote;
    }

    return project.autoQuote || null;
  }

  function quotePersistPayload(project = {}){
    const auto = getReliableQuote(project);
    const q = auto && auto.quote ? auto.quote : {};
    const final = Number(q.final || q.suggested || project.finalPrice || project.quoteTotal || 0);
    const printMinutes = Math.round(Number(q.printHours || 0) * 60);
    const printer = auto?.analysis?.metadata?.printer || auto?.settings?.printer || project.printerName || project.printer || "";

    const payload = {
      autoQuote: auto || project.autoQuote || null,
      printerName: printer || project.printerName || "",
      printEstimatedMinutes: printMinutes || project.printEstimatedMinutes || 0
    };

    if(final > 0){
      payload.finalPrice = final;
      payload.quoteTotal = final;
      payload.quote = {
        ...(project.quote || {}),
        price: final,
        total: final,
        final: final,
        quoteNumber: auto?.quoteNumber || project.quote?.quoteNumber || "",
        updatedAt: new Date().toISOString()
      };
    }

    Object.assign(project, payload);
    return payload;
  }

  const MTS_API_BASE = "https://bubbly-vibrancy-production.up.railway.app";

  async function notifyStatus(project, status){
    if(!project?.id) throw new Error("Identifiant du projet manquant.");

    const response = await fetch(MTS_API_BASE + "/api/project/status", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({
        projectId:project.id,
        status,
        project:{
          id:project.id,
          name:project.name || "",
          email:project.email || "",
          phone:project.phone || "",
          projectType:project.projectType || "",
          message:project.message || "",
          shopifyOrderId:project.shopifyOrderId || "",
          shopifyOrderName:project.shopifyOrderName || "",
          shopifyDraftOrderId:project.shopifyDraftOrderId || "",
          price:projectPrice(project),
          finalPrice:project.finalPrice || project.price || "",
          orderName:project.shopifyOrderName || "",
          trackingCompany:project.trackingCompany || project.carrier || "",
          trackingNumber:project.trackingNumber || project.tracking || "",
          trackingUrl:project.trackingUrl || ""
        }
      })
    });

    const data = await response.json().catch(()=>null);
    if(!response.ok || !data?.ok){
      throw new Error(data?.error || `Railway HTTP ${response.status}`);
    }
    if(!data.firestoreUpdated){
      throw new Error("Railway n'a pas confirmé l'enregistrement dans Firestore.");
    }

    if(data.mail?.failed){
      console.warn("Statut enregistré, mais suivi client non envoyé :", data.mail);
    }

    return data;
  }

  async function updateProjectStatus(project, status, type){
    const extra = {};
    if(status === "printing"){
      extra.printStartedAt = new Date().toISOString();
      extra.printEstimatedMinutes = projectPrintMinutes(project) || 0;
      extra.printerName = projectPrinter(project) || project.printerName || "";
    }
    if(["finishing","ready","shipped","done"].includes(status)){
      extra.printEndedAt = extra.printEndedAt || new Date().toISOString();
    }

    const productionStatuses = ["printing","finishing","ready","shipped"];

    if(productionStatuses.includes(status)){
      // Railway et son Admin SDK deviennent la source de vérité. La promesse ne
      // se résout que lorsque Firestore a réellement confirmé la sauvegarde.
      await notifyStatus({...project, ...extra}, status);

      // Les métadonnées atelier ne sont pas envoyées par la route de suivi.
      // On les fusionne séparément sans réécrire le statut ni son historique.
      if(Object.keys(extra).length){
        await MTS.state.db.collection("custom_requests").doc(project.id).set({
          ...savedPricePayload(project),
          ...extra,
          updatedAt:firebase.firestore.FieldValue.serverTimestamp()
        }, {merge:true});
      }
    }else{
      await MTS.state.db.collection("custom_requests").doc(project.id).set({
        ...savedPricePayload(project),
        ...extra,
        status,
        updatedAt:firebase.firestore.FieldValue.serverTimestamp(),
        history:firebase.firestore.FieldValue.arrayUnion({
          type:type || "status_changed",
          label:(type === "main_action" ? "Action principale : " : "Statut : ") + MTS.statusLabel(status),
          date:new Date().toISOString()
        })
      }, {merge:true});
    }

    // Mise à jour immédiate de l'objet partagé par le web et le WebView du .exe.
    Object.assign(project, extra, {status});
    if(MTS.Projects?.renderDetail) MTS.Projects.renderDetail(project);
    if(MTS.Projects?.renderList) MTS.Projects.renderList();
  }


  async function createShopifyDraft(project){
    const persist = quotePersistPayload(project);
    const price = Number(persist.finalPrice || projectPrice(project) || 0);

    if(!price || price <= 0){
      alert("Calcule le devis atelier avant de créer le devis Shopify.");
      MTS.state.activeProjectTab = "quote";
      renderDetail(project);
      return;
    }

    const response = await fetch(MTS_API_BASE + "/api/shopify/create-draft-order", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({
        project:{
          ...project,
          ...persist,
          price,
          finalPrice:price
        }
      })
    });

    const data = await response.json().catch(()=>null);
    if(!response.ok || !data?.ok){
      throw new Error(data?.error || "Création du devis Shopify impossible.");
    }

    const updatePayload = {
      ...persist,
      shopifyDraftOrderId:data.draftOrderId || "",
      shopifyDraftOrderName:data.draftOrderName || "",
      shopifyInvoiceUrl:data.invoiceUrl || "",
      status:"quoted",
      updatedAt:firebase.firestore.FieldValue.serverTimestamp(),
      history:firebase.firestore.FieldValue.arrayUnion({
        type:"shopify_draft_created",
        label:"Devis Shopify créé " + (data.draftOrderName || ""),
        date:new Date().toISOString()
      }),
      files:firebase.firestore.FieldValue.arrayUnion(quoteFileRecord(project, data, "created"))
    };

    await MTS.state.db.collection("custom_requests").doc(project.id).set(updatePayload, { merge:true });

    Object.assign(project, updatePayload, {
      status:"quoted",
      shopifyDraftOrderId:data.draftOrderId || "",
      shopifyDraftOrderName:data.draftOrderName || "",
      shopifyInvoiceUrl:data.invoiceUrl || ""
    });

    MTS.state.activeProjectTab = "project";
    renderDetail(project);
    renderList();
    renderWorkshopBar();

    alert("Devis Shopify créé : " + (data.draftOrderName || "OK"));
  }

  async function sendShopifyQuote(project){
    const persist = quotePersistPayload(project);
    const price = Number(persist.finalPrice || projectPrice(project) || 0);

    if(!price || price <= 0){
      alert("Calcule le devis atelier avant d'envoyer le lien de paiement.");
      MTS.state.activeProjectTab = "quote";
      renderDetail(project);
      return;
    }

    const response = await fetch(MTS_API_BASE + "/api/shopify/send-quote", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({
        project:{
          ...project,
          ...persist,
          price,
          finalPrice:price
        }
      })
    });

    const data = await response.json().catch(()=>null);
    if(!response.ok || !data?.ok){
      throw new Error(data?.error || "Envoi du devis impossible.");
    }

    const updatePayload = {
      ...persist,
      shopifyDraftOrderId:data.draftOrderId || project.shopifyDraftOrderId || "",
      shopifyDraftOrderName:data.draftOrderName || project.shopifyDraftOrderName || "",
      shopifyInvoiceUrl:data.invoiceUrl || project.shopifyInvoiceUrl || "",
      status:"quoted",
      updatedAt:firebase.firestore.FieldValue.serverTimestamp(),
      history:firebase.firestore.FieldValue.arrayUnion({
        type:"shopify_quote_sent",
        label:"Devis + lien paiement envoyé " + (data.draftOrderName || ""),
        date:new Date().toISOString()
      }),
      files:firebase.firestore.FieldValue.arrayUnion(quoteFileRecord(project, data, "sent"))
    };

    await MTS.state.db.collection("custom_requests").doc(project.id).set(updatePayload, { merge:true });

    Object.assign(project, updatePayload, {
      status:"quoted",
      shopifyDraftOrderId:data.draftOrderId || project.shopifyDraftOrderId || "",
      shopifyDraftOrderName:data.draftOrderName || project.shopifyDraftOrderName || "",
      shopifyInvoiceUrl:data.invoiceUrl || project.shopifyInvoiceUrl || ""
    });

    MTS.state.activeProjectTab = "project";
    renderDetail(project);
    renderList();
    renderWorkshopBar();

    alert("Devis envoyé au client.");
  }

  async function verifyPayment(project){
    const draftOrderId = project.shopifyDraftOrderId || "";
    if(!draftOrderId){
      alert("Aucun devis Shopify lié à ce projet.");
      return;
    }

    const response = await fetch(MTS_API_BASE + "/api/shopify/draft-order-status", {
      method:"POST",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({ draftOrderId })
    });

    const data = await response.json().catch(()=>null);
    if(!response.ok || !data?.ok){
      throw new Error(data?.error || "Vérification paiement impossible.");
    }

    const update = {
      ...savedPricePayload(project),
      shopifyDraftOrderId:data.draftOrderId || draftOrderId,
      shopifyDraftOrderName:data.draftOrderName || project.shopifyDraftOrderName || "",
      shopifyInvoiceUrl:data.invoiceUrl || project.shopifyInvoiceUrl || "",
      shopifyOrderId:data.orderId || project.shopifyOrderId || "",
      shopifyOrderName:data.orderName || project.shopifyOrderName || "",
      shopifyFinancialStatus:data.financialStatus || "",
      shopifyFulfillmentStatus:data.fulfillmentStatus || "",
      updatedAt:firebase.firestore.FieldValue.serverTimestamp(),
      history:firebase.firestore.FieldValue.arrayUnion({
        type:"shopify_payment_checked",
        label:data.paid ? `Paiement confirmé ${data.orderName || ""}` : "Paiement vérifié : pas encore payé",
        date:new Date().toISOString()
      })
    };

    if(data.paid){
      update.status = "paid";
      update.files = firebase.firestore.FieldValue.arrayUnion({
        id:`payment-${Date.now()}-${Math.random().toString(16).slice(2)}`,
        type:"payment_received",
        documentType:"payment",
        icon:"💳",
        name:`Paiement reçu ${data.orderName || project.shopifyDraftOrderName || "Shopify"}`,
        description:"Paiement confirmé depuis Shopify",
        amount:projectPrice(project) || "",
        shopifyRef:data.orderName || project.shopifyDraftOrderName || "",
        createdAt:new Date().toISOString()
      });
    }

    await MTS.state.db.collection("custom_requests").doc(project.id).update(update);
    alert(data.paid ? "Paiement confirmé ✅" : "Paiement non reçu pour le moment.");
  }

  function shopifyRef(project){
    return project.shopifyOrderName || project.orderName || project.shopifyDraftOrderName || project.shopifyInvoiceUrl && "Devis Shopify" || "—";
  }

  function paymentLabel(project){
    const status = project.shopifyFinancialStatus || "";
    if((project.status || "") === "paid" || project.shopifyOrderId) return "✅ Payé";
    if(status) return status;
    return "À vérifier";
  }

  function effectiveProjectStatus(project = {}){
    const raw = String(project.status || "new");
    if(raw && raw !== "new") return raw;
    if(project.shopifyOrderId || project.orderName || project.paidAt || project.completedAt) return "paid";
    if(project.shopifyDraftOrderId || project.shopifyDraftOrderName || project.shopifyInvoiceUrl) return "quoted";
    return "new";
  }

  function mainActionFor(project){
    const status = effectiveProjectStatus(project);

    if(status === "new" || status === "progress"){
      const hasQuote = !!(project.quote || project.autoQuote);
      return {label: hasQuote ? "📄 Voir / générer le devis PDF" : "📄 Générer le devis", tab:"quote", status:null, className:"mts-primary-orange"};
    }

    if(status === "quoted"){
      return {label:"💳 Marquer accepté / paiement", tab:null, status:"accepted", className:"mts-primary-purple"};
    }

    if(status === "accepted"){
      return {label:"✅ Marquer payé", tab:null, status:"paid", className:"mts-primary-green"};
    }

    if(status === "paid"){
      return {label:"🖨️ Lancer la production", tab:null, status:"printing", className:"mts-primary-blue"};
    }

    if(status === "printing"){
      return {label:"✅ Impression terminée", tab:null, status:"finishing", className:"mts-primary-green"};
    }

    if(status === "finishing"){
      return {label:"📦 Prêt à expédier", tab:null, status:"ready", className:"mts-primary-blue"};
    }

    if(status === "ready"){
      return {label:"🚚 Marquer expédié", tab:null, status:"shipped", className:"mts-primary-purple"};
    }

    if(status === "shipped"){
      return {label:"✅ Terminer le projet", tab:null, status:"done", className:"mts-primary-green"};
    }

    return {label:"📁 Voir le projet", tab:"project", status:null, className:"mts-primary-orange"};
  }

  function stepClass(project, step){
    const order = ["new","progress","quoted","accepted","paid","printing","finishing","ready","shipped","done"];
    const current = effectiveProjectStatus(project);
    const idx = order.indexOf(current);
    const sidx = order.indexOf(step);
    if(current === "progress" && step === "new") return "active";
    if(sidx < idx) return "done";
    if(sidx === idx) return "active";
    return "";
  }

  const MANUAL_STATUS_OPTIONS = [
    ["new","Nouvelle demande"], ["progress","Étude en cours"],
    ["quoted","Devis envoyé"], ["accepted","Devis accepté"],
    ["paid","Payé"], ["printing","En impression"],
    ["finishing","Finition / contrôle"], ["ready","Prêt à expédier"],
    ["shipped","Expédié"], ["done","Terminé"], ["archived","Archivé"]
  ];

  function openManualMail(project, kind = "general"){
    if(!project.email) throw new Error("Aucune adresse e-mail n'est renseignée pour ce client.");
    const name = project.name || "";
    const ref = shopifyRef(project) !== "—" ? shopifyRef(project) : `projet ${String(project.id||"").slice(0,6).toUpperCase()}`;
    const templates = {
      general:["Votre projet MoRetro3D", `Bonjour ${name},\n\nJe vous contacte au sujet de votre ${ref}.\n\nCordialement,\nMorgan — MoRetro3D`],
      quote:["Votre devis MoRetro3D", `Bonjour ${name},\n\nVotre devis est prêt. Vous pouvez le consulter et me répondre si vous souhaitez une modification.\n\nCordialement,\nMorgan — MoRetro3D`],
      paid:["Paiement reçu — MoRetro3D", `Bonjour ${name},\n\nVotre paiement a bien été reçu. Merci pour votre confiance.\n\nCordialement,\nMorgan — MoRetro3D`],
      printing:["Votre création est en fabrication", `Bonjour ${name},\n\nLa fabrication de votre création est maintenant lancée dans l'atelier.\n\nCordialement,\nMorgan — MoRetro3D`],
      ready:["Votre commande est prête", `Bonjour ${name},\n\nVotre création est terminée et prête pour son expédition ou sa remise en main propre.\n\nCordialement,\nMorgan — MoRetro3D`],
      shipped:["Votre commande a été expédiée", `Bonjour ${name},\n\nVotre commande a été expédiée.${project.trackingNumber ? `\nNuméro de suivi : ${project.trackingNumber}` : ""}${project.trackingUrl ? `\nSuivi : ${project.trackingUrl}` : ""}\n\nCordialement,\nMorgan — MoRetro3D`]
    };
    const [subject, body] = templates[kind] || templates.general;
    window.location.href = `mailto:${encodeURIComponent(project.email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  async function markManualPayment(project){
    const amount = Number(String(prompt("Montant reçu (€)", projectPrice(project) || "") || "").replace(",","."));
    if(!Number.isFinite(amount) || amount <= 0) throw new Error("Montant invalide.");
    const method = (prompt("Mode de paiement (espèces, virement, carte, chèque…)", "Virement") || "").trim();
    if(!method) throw new Error("Mode de paiement manquant.");
    const reference = (prompt("Référence du paiement (facultatif)", "") || "").trim();
    const paidAt = new Date().toISOString();
    await MTS.state.db.collection("custom_requests").doc(project.id).set({
      status:"paid",
      finalPrice:amount,
      quoteTotal:amount,
      manualPayment:{amount, method, reference, paidAt},
      paidAt,
      paymentSource:"manual",
      updatedAt:firebase.firestore.FieldValue.serverTimestamp(),
      history:firebase.firestore.FieldValue.arrayUnion({
        type:"manual_payment", label:`Paiement hors Shopify reçu — ${method} — ${amount.toFixed(2)} €`, date:paidAt
      })
    }, {merge:true});
    Object.assign(project, {status:"paid", finalPrice:amount, quoteTotal:amount, manualPayment:{amount,method,reference,paidAt}, paidAt, paymentSource:"manual"});
    renderDetail(project);
  }

  function invoiceHtml(project, invoice){
    const esc = MTS.escapeHtml;
    return `<!doctype html><html lang="fr"><head><meta charset="utf-8"><title>${esc(invoice.number)}</title><style>body{font-family:Arial,sans-serif;color:#171923;margin:0;padding:45px}header{display:flex;justify-content:space-between;border-top:7px solid #7b2cff;padding-top:22px}h1{font-size:34px;margin:0}.meta{text-align:right}.box{margin-top:36px;padding:22px;border:1px solid #ddd;border-radius:12px}.row{display:flex;justify-content:space-between;gap:20px}.total{margin-top:25px;background:#171923;color:#fff;padding:22px;font-size:25px;font-weight:700}.legal{margin-top:45px;color:#666;font-size:12px;line-height:1.6}@media print{body{padding:20px}}</style></head><body><header><div><h1>MoRetro3D</h1><p>Créations et impressions 3D personnalisées</p></div><div class="meta"><strong>FACTURE</strong><br>${esc(invoice.number)}<br>${esc(new Date(invoice.createdAt).toLocaleDateString("fr-FR"))}</div></header><div class="box"><div class="row"><div><strong>Client</strong><br>${esc(project.name||"Non renseigné")}<br>${esc(project.email||"")}<br>${esc(project.phone||"")}</div><div><strong>Projet</strong><br>${esc(project.projectType||"Création personnalisée")}<br>${esc(invoice.paymentMethod||"")}</div></div></div><div class="total row"><span>Total</span><span>${Number(invoice.amount).toFixed(2).replace(".",",")} €</span></div><div class="legal">Morgan Duncas — MoRetro3D<br>SIREN 944 355 874 — SIRET 944 355 874 00016<br>TVA non applicable, art. 293 B du CGI.</div><script>window.addEventListener("load",()=>setTimeout(()=>window.print(),250));<\/script></body></html>`;
  }

  async function createManualInvoice(project){
    const number = (prompt("Numéro de facture", `FAC-${new Date().toISOString().slice(0,10).replaceAll("-","")}-${String(project.id||"").slice(0,5).toUpperCase()}`) || "").trim();
    if(!number) throw new Error("Numéro de facture manquant.");
    const amount = Number(String(prompt("Montant facturé (€)", projectPrice(project) || "") || "").replace(",","."));
    if(!Number.isFinite(amount) || amount <= 0) throw new Error("Montant invalide.");
    const paymentMethod = (prompt("Mode de règlement", project.manualPayment?.method || "Virement") || "").trim();
    const invoice = {number, amount, paymentMethod, createdAt:new Date().toISOString(), source:"manual"};
    const record = {
      id:`invoice-${Date.now()}-${Math.random().toString(16).slice(2)}`,
      type:"manual_invoice", documentType:"invoice", category:"documents", icon:"🧾",
      name:`Facture ${number}`, title:`Facture ${number}`, amount, invoiceNumber:number,
      description:`Facture manuelle — ${paymentMethod}`, createdAt:invoice.createdAt
    };
    await MTS.state.db.collection("custom_requests").doc(project.id).set({
      manualInvoice:invoice,
      files:firebase.firestore.FieldValue.arrayUnion(record),
      updatedAt:firebase.firestore.FieldValue.serverTimestamp(),
      history:firebase.firestore.FieldValue.arrayUnion({type:"manual_invoice",label:`Facture ${number} créée`,date:invoice.createdAt})
    }, {merge:true});
    project.manualInvoice = invoice;
    project.files = [...(Array.isArray(project.files) ? project.files : []), record];
    const popup = window.open("", "_blank");
    if(!popup) throw new Error("Autorise les fenêtres contextuelles pour ouvrir la facture.");
    popup.document.open(); popup.document.write(invoiceHtml(project, invoice)); popup.document.close();
  }

  function renderProjectHero(project){
    const price = projectPrice(project);
    const files = Array.isArray(project.files) ? project.files : [];
    const quote = project.autoQuote || null;
    const q = quote && quote.quote ? quote.quote : {};
    const a = quote && quote.analysis ? quote.analysis : {};
    const main = mainActionFor(project);
    const received = project.createdAt ? MTS.dateLabel(project.createdAt) : "—";
    const orderRef = shopifyRef(project);

    return `
      <div class="mts-v7-shell mts-v18-shell">
        <div class="mts-v7-header">
          <div>
            <div class="mts-v7-title-row">
              <h3>📦 ${MTS.escapeHtml(orderRef !== "—" ? orderRef : "Projet #" + String(project.id || "").slice(0,6).toUpperCase())}</h3>
              <span class="mts-badge ${MTS.escapeHtml(effectiveProjectStatus(project))}">${MTS.escapeHtml(MTS.statusLabel(effectiveProjectStatus(project)))}</span>
              <div class="mts-v18-menu-wrap">
                <button type="button" class="mts-v18-menu-btn" data-project-menu="toggle">⋮</button>
                <div class="mts-v18-menu" id="mtsProjectMoreMenu" hidden>
                  <div class="mts-v18-menu-title">Étape manuelle</div>
                  ${MANUAL_STATUS_OPTIONS.map(([status,label])=>`<button type="button" data-project-menu-action="status:${status}">${effectiveProjectStatus(project)===status ? "✓ " : ""}${MTS.escapeHtml(label)}</button>`).join("")}
                  <div class="mts-v18-menu-sep"></div>
                  <div class="mts-v18-menu-title">Paiement et facture</div>
                  <button type="button" data-project-menu-action="manual-payment">💶 Marquer payé hors Shopify</button>
                  <button type="button" data-project-menu-action="manual-invoice">🧾 Créer une facture manuelle</button>
                  <div class="mts-v18-menu-sep"></div>
                  <div class="mts-v18-menu-title">E-mails manuels</div>
                  <button type="button" data-project-menu-action="mail:general">✉️ Écrire au client</button>
                  <button type="button" data-project-menu-action="mail:quote">📄 Mail devis prêt</button>
                  <button type="button" data-project-menu-action="mail:paid">💳 Mail paiement reçu</button>
                  <button type="button" data-project-menu-action="mail:printing">🖨️ Mail fabrication lancée</button>
                  <button type="button" data-project-menu-action="mail:ready">📦 Mail commande prête</button>
                  <button type="button" data-project-menu-action="mail:shipped">🚚 Mail commande expédiée</button>
                  <div class="mts-v18-menu-sep"></div>
                  <div class="mts-v18-menu-title">Projet</div>
                  <button type="button" data-project-menu-action="duplicate">📋 Dupliquer le projet</button>
                  <button type="button" data-project-menu-action="archive">📦 Archiver le projet</button>
                  <button type="button" data-project-menu-action="export">📤 Export PDF</button>
                  <button type="button" class="danger" data-project-menu-action="delete">🗑️ Supprimer le projet</button>
                </div>
              </div>
            </div>
            <p>${MTS.escapeHtml(project.projectType || "Projet sur mesure")} • Reçu le ${MTS.escapeHtml(received)}</p>
              ${documentSummary(project)}
          </div>

          <div class="mts-v7-price">
            <span>Montant</span>
            <strong>${price ? MTS.money(price) : "À définir"}</strong>
          </div>
        </div>

        <div class="mts-v7-layout">
          <aside class="mts-v7-left">
            ${(MTS.Viewer && MTS.Viewer.render) ? MTS.Viewer.render(project) : ""}
            <div class="mts-v7-mini-actions">
              <button type="button" data-project-tab-short="files">📁 Fichiers</button>
              <button type="button" data-project-tab-short="gallery">📷 Galerie</button>
            </div>
          </aside>

          <section class="mts-v7-center">
            <div class="mts-v7-card-title">Centre de contrôle</div>

            <div class="mts-v7-info-columns mts-v18-order-grid">
              <div class="mts-v7-info-card">
                <h4>📦 Shopify</h4>
                <p><strong>${MTS.escapeHtml(orderRef)}</strong></p>
                <p>Paiement : ${MTS.escapeHtml(paymentLabel(project))}</p>
                <p>${project.shopifyInvoiceUrl ? `<a href="${MTS.escapeHtml(project.shopifyInvoiceUrl)}" target="_blank" rel="noopener">Lien de paiement</a>` : "Lien de paiement : —"}</p>
              </div>

              <div class="mts-v7-info-card">
                <h4>👤 Client</h4>
                <p><strong>${MTS.escapeHtml(project.name||"Non renseigné")}</strong></p>
                <p>${MTS.escapeHtml(project.email||"Email non renseigné")}</p>
                <p>${MTS.escapeHtml(project.phone||"Téléphone non renseigné")}</p>
              </div>

              <div class="mts-v7-info-card">
                <h4>💶 Commande</h4>
                <p><strong>${price ? MTS.money(price) : "À définir"}</strong></p>
                <p>${MTS.escapeHtml(project.projectType || "Produit à définir")}</p>
                <p>${files.length} fichier(s)</p>
              </div>

              <div class="mts-v7-info-card">
                <h4>🚚 Livraison</h4>
                <p><strong>${MTS.escapeHtml(project.trackingCompany || project.carrier || "Transporteur à venir")}</strong></p>
                <p>${MTS.escapeHtml(project.trackingNumber || project.tracking || "Suivi non disponible")}</p>
                <p>${project.trackingUrl ? `<a href="${MTS.escapeHtml(project.trackingUrl)}" target="_blank" rel="noopener">Suivre le colis</a>` : "Lien suivi : —"}</p>
              </div>
            </div>

            <div class="mts-v7-steps mts-v18-steps">
              <div class="${stepClass(project,"new")}"><span>📝</span><em>Demande</em></div>
              <div class="${stepClass(project,"quoted")}"><span>📄</span><em>Devis</em></div>
              <div class="${stepClass(project,"paid")}"><span>💳</span><em>Paiement</em></div>
              <div class="${stepClass(project,"printing")}"><span>🖨️</span><em>Fabrication</em></div>
              <div class="${stepClass(project,"finishing")}"><span>✨</span><em>Finition</em></div>
              <div class="${stepClass(project,"ready")}"><span>📦</span><em>Prêt</em></div>
              <div class="${stepClass(project,"shipped")}"><span>🚚</span><em>Expédié</em></div>
              <div class="${stepClass(project,"done")}"><span>✅</span><em>Terminé</em></div>
            </div>

            <div class="mts-v18-control-panel">
              <button type="button" class="mts-v18-checkout-btn" data-shopify-action="verify">✅ Vérifier paiement</button>
              <button type="button" class="mts-v7-main-action ${main.className}" data-main-action-status="${main.status || ""}" data-main-action-tab="${main.tab || ""}">
                ${main.label}
                <b>→</b>
              </button>
            </div>
          </section>
        </div>
      </div>
    `;
  }


  function renderDetail(project){
    const wrap = MTS.$("mtsProjectDetail");
    if(!wrap) return;

    if(!project){
      wrap.innerHTML = '<div class="mts-empty">Sélectionne un projet à gauche.</div>';
      return;
    }

    const mailBody = "Bonjour " + (project.name || "") + "\n\nMerci pour votre demande concernant : " + (project.projectType || "votre projet") + ".\n\n";
    const mailto = `mailto:${encodeURIComponent(project.email||"")}?subject=${encodeURIComponent("Votre projet sur mesure - MoRetro 3D")}&body=${encodeURIComponent(mailBody)}`;

    wrap.innerHTML = `
      ${renderProjectHero(project)}

      ${renderTabs(project)}
    `;

    bindDetail(project);
  }

  function bindDetail(project){

    document.querySelectorAll("[data-project-menu]").forEach(btn=>{
      btn.addEventListener("click",()=>{
        const menu = document.getElementById("mtsProjectMoreMenu");
        if(menu) menu.hidden = !menu.hidden;
      });
    });

    document.querySelectorAll("[data-project-menu-action]").forEach(btn=>{
      btn.addEventListener("click", async()=>{
        const action = btn.dataset.projectMenuAction;
        document.getElementById("mtsProjectMoreMenu")?.setAttribute("hidden", "hidden");
        try{
          if(action.startsWith("status:")){
            const status = action.split(":")[1];
            const label = MANUAL_STATUS_OPTIONS.find(item=>item[0]===status)?.[1] || status;
            if(!confirm(`Passer manuellement le projet à l'étape « ${label} » ?`)) return;
            await updateProjectStatus(project, status, "manual_status");
            return;
          }
          if(action === "manual-payment"){
            await markManualPayment(project);
            alert("Paiement hors Shopify enregistré.");
            return;
          }
          if(action === "manual-invoice"){
            await createManualInvoice(project);
            return;
          }
          if(action.startsWith("mail:")){
            openManualMail(project, action.split(":")[1]);
            return;
          }
          if(action === "delete"){
            if(!confirm("Supprimer définitivement ce projet ? Cette action est irréversible.")) return;
            await MTS.state.db.collection("custom_requests").doc(project.id).delete();
            MTS.state.selectedProjectId = null;
            return;
          }
          if(action === "archive"){
            await updateProjectStatus(project, "archived", "project_archived");
            return;
          }
          if(action === "duplicate"){
            const copy = {...project};
            delete copy.id;
            copy.status = "new";
            copy.createdAt = firebase.firestore.FieldValue.serverTimestamp();
            copy.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
            copy.history = firebase.firestore.FieldValue.arrayUnion({type:"duplicated", label:"Projet dupliqué", date:new Date().toISOString()});
            await MTS.state.db.collection("custom_requests").add(copy);
            alert("Projet dupliqué.");
            return;
          }
          if(action === "export"){
            window.print();
            return;
          }
        }catch(err){
          alert("Erreur : " + err.message);
        }
      });
    });

    document.querySelectorAll("[data-project-tab-short]").forEach(btn=>{
      btn.addEventListener("click",()=>{
        MTS.state.activeProjectTab = btn.dataset.projectTabShort || "project";
        renderDetail(project);
      });
    });

    document.querySelectorAll("[data-open-saved-quote-pdf]").forEach(btn=>{
      btn.addEventListener("click",()=>{
        if(MTS.Quotes && typeof MTS.Quotes.openQuoteDocument === "function"){
          MTS.Quotes.openQuoteDocument(project);
        }else{
          alert("Le générateur de PDF n'est pas chargé.");
        }
      });
    });


    document.querySelectorAll("[data-main-action-tab]").forEach(btn=>{
      btn.addEventListener("click",async()=>{
        const tab = btn.dataset.mainActionTab;
        const status = btn.dataset.mainActionStatus;

        if(tab){
          MTS.state.activeProjectTab = tab;
          renderDetail(project);
          setTimeout(()=>{
            const target = document.querySelector(".mts-project-tabs");
            if(target) target.scrollIntoView({behavior:"smooth", block:"start"});
          }, 50);
          return;
        }

        if(status){
          btn.disabled = true;
          try{
            await updateProjectStatus(project, status, "main_action");
          }catch(err){
            alert("Erreur : " + err.message);
          }finally{
            btn.disabled = false;
          }
        }
      });
    });


    document.querySelectorAll("[data-project-tab]").forEach(btn=>{
      btn.addEventListener("click",()=>{
        MTS.state.activeProjectTab = btn.dataset.projectTab || "project";
        renderDetail(project);
      });
    });

    MTS.Files.bindUpload(project);
    MTS.Quotes.bind(project);

    document.querySelectorAll("[data-shopify-action]").forEach(btn=>{
      btn.addEventListener("click",async()=>{
        const action = btn.dataset.shopifyAction;
        btn.disabled = true;

        try{
          if(action === "create") await createShopifyDraft(project);
          if(action === "send") await sendShopifyQuote(project);
          if(action === "verify") await verifyPayment(project);
        }catch(err){
          alert("Erreur Shopify : " + err.message);
        }finally{
          btn.disabled = false;
        }
      });
    });

    MTS.on("mtsSaveNotes","click",async()=>{
      try{
        await MTS.state.db.collection("custom_requests").doc(project.id).update({
          internalNotes:MTS.$("mtsInternalNotes")?.value || "",
          updatedAt:firebase.firestore.FieldValue.serverTimestamp()
        });
      }catch(err){
        alert("Erreur : " + err.message);
      }
    });

    document.querySelectorAll("[data-status]").forEach(btn=>{
      btn.addEventListener("click",async()=>{
        const action = btn.dataset.status;
        btn.disabled = true;

        try{
          if(action === "delete"){
            if(confirm("Supprimer définitivement ce projet ?")){
              await MTS.state.db.collection("custom_requests").doc(project.id).delete();
              MTS.state.selectedProjectId = null;
            }
          }else{
            await updateProjectStatus(project, action, "status_changed");
          }
        }catch(err){
          alert("Erreur : " + err.message);
        }finally{
          btn.disabled = false;
        }
      });
    });
  }

  function listen(){
    if(!MTS.state.db) return;

    if(MTS.state.unsubProjects) MTS.state.unsubProjects();

    MTS.state.unsubProjects = MTS.state.db.collection("custom_requests").onSnapshot(snap=>{
      MTS.state.projects = [];
      snap.forEach(doc=>MTS.state.projects.push({id:doc.id, ...doc.data()}));
      MTS.App.renderAll();
      renderWorkshopBar();
      startWorkshopTimer();
    });
  }

  MTS.Projects = {
    listen,
    renderList,
    renderDetail,
    filtered
  };

})(window.MTS);

/* V24.4 hook étiquettes Sendcloud sur Projets */
(function(){
  function addProjectShippingButtons(){
    if(!window.MTS || !MTS.state || !Array.isArray(MTS.state.projects)) return;

    document.querySelectorAll("[data-project-id]").forEach(card=>{
      if(card.querySelector(".mts-project-sendcloud-btn")) return;
      const projectId = card.dataset.projectId;
      const project = MTS.state.projects.find(p=>String(p.id||p.docId)===String(projectId));
      if(!project) return;

      const actions = card.querySelector(".mts-actions,.mts-project-main-actions,.mts-detail-actions") || card;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "mts-btn mts-soft mts-project-sendcloud-btn";
      btn.textContent = "📦 Étiquette Sendcloud";
      btn.addEventListener("click", e=>{
        e.preventDefault();
        e.stopPropagation();
        if(!MTS.Shipping){
          alert("Module mts-shipping.js manquant.");
          return;
        }
        MTS.Shipping.openShippingModal(MTS.Shipping.shippingPayloadFromProject(project));
      });
      actions.appendChild(btn);
    });
  }

  document.addEventListener("click",()=>setTimeout(addProjectShippingButtons,200));
  document.addEventListener("DOMContentLoaded",()=>setInterval(addProjectShippingButtons,1500));
  setTimeout(addProjectShippingButtons,1200);
})();
